<template>
	<b-modal class="modal-lg" size="lg" id="ModalAddEditEmailNotification" ref="addEditEmailNotification-modal" :title="editEmailNotificationModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetModal('main')">
		<template slot="modal-header" slot-scope="{ close }">
			<h5 class="modal-title text-light">{{ t(editEmailNotificationModal.modalData.title, editEmailNotificationModal.modalData.title) }}</h5>
			<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
		</template>
		<template slot="default">
			<div class="row modal-body-log">
				<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
					<b-input-group class="py-2">
						<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
							<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('strinIdentifierText', 'strinIdentifierText') }}</span></b-input-group-text>
						</b-input-group-prepend>
						<b-form-input id="user_password" v-model="editEmailNotificationModal.modalData.string_id" :disabled="editEmailNotificationModal.modalData.component == 'editNotification'"></b-form-input>
					</b-input-group>
					<b-input-group class="py-2">
						<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
							<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('emailNotificationText', 'emailNotificationText') }}</span></b-input-group-text>
						</b-input-group-prepend>
						<b-form-textarea id="email-to" v-model="editEmailNotificationModal.modalData.notification_message" class="form-control" rows="5" max-rows="5" required>
						</b-form-textarea>
					</b-input-group>																																				
				</b-form-group>
			</div>
		</template>
		<template slot="modal-footer" slot-scope="{ close }">
			<div v-if="editEmailNotificationModal.modalData.component == 'editNotification'">
				<button type="button" class="btn btn-secondary mr-1" @click="close()">Cancel</button>
				<button v-if="!buttonIsBusy" type="button" class="btn btn-primary" @click="updateEmailNotification()">{{ t('updateNotificationBtn', 'updateNotificationBtn') }}</button>							
				<b-button v-else variant="primary" disabled>
					<b-spinner small type="grow"></b-spinner>
					{{ t('updateNotificationBtn', 'updateNotificationBtn') }}
				</b-button>
			</div>
			<div v-else>
				<button type="button" class="btn btn-secondary mr-1" @click="close()">Cancel</button>
				<button v-if="!buttonIsBusy" type="button" class="btn btn-primary" @click="addEmailNotification()">{{ t('addNotificationBtn', 'addNotificationBtn') }}</button>							
				<b-button v-else variant="primary" disabled>
					<b-spinner small type="grow"></b-spinner>
					{{ t('addNotificationBtn', 'addNotificationBtn') }}
				</b-button>
			</div>
		</template>	
	</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
	name: 'ModalEditEmailNotification',
	data() {
		return {
			buttonIsBusy: false,
			editEmailNotificationModal: null
		}
	},
  inject: [
    'resetModal'
  ],
  components:{
    ResponseInfo
  },	
	created() {
		this.editEmailNotificationModal = this.$attrs.modal
	},
	methods: {
		updateEmailNotification() {
			this.buttonIsBusy = true
			this.$store.dispatch('emailNotificationsStore/updateEmailNotification', {
				stringId: this.editEmailNotificationModal.modalData.string_id,
				notification: this.editEmailNotificationModal.modalData.notification_message,
				languageCode: this.editEmailNotificationModal.modalData.languageCode
			}).then(() => {
				this.buttonIsBusy = false
				this.$refs['addEditEmailNotification-modal'].hide()
				this.$parent.getEmailNotificationTranslationList()
			})
		},
		addEmailNotification() {
			this.buttonIsBusy = true
			this.$store.dispatch('emailNotificationsStore/addEmailNotification', {
				stringId: this.editEmailNotificationModal.modalData.string_id,
				notification: this.editEmailNotificationModal.modalData.notification_message,
				languageCode: this.editEmailNotificationModal.modalData.languageCode
			}).then(() => {
				this.buttonIsBusy = false
				this.$refs['addEditEmailNotification-modal'].hide()
				this.$parent.getEmailNotificationTranslationList()
			})			
		}
	}
}
</script>

<style scoped>

</style>